/**
 * Utility function to try to push an event to data layer, and report any failures.
 */
export function sendRegistrationEvent(payload) {
    console.log("[GAREG] Sending registration event...", payload);
    try {
        window.dataLayer.push(payload);
    }
    catch (e) {
        console.warn("GA Event error tracking registration event:" + payload);
    }
}
//# sourceMappingURL=sendRegistrationEvent.js.map